// Ensure dayjs plugins (utc, timezone, isoWeek, weekday, …) are registered before
// the pickers use them. Also the single source of the configured dayjs instance.
import 'utils/dayjs';

import { Calendar as AntdCalendar, DatePicker as AntdDatePicker } from 'antd';

export const { RangePicker, TimePicker, WeekPicker, MonthPicker, YearPicker, QuarterPicker } = AntdDatePicker;

export const Calendar = AntdCalendar;

export const DatePicker = AntdDatePicker;
